const OPERATOR_LOGIN = 'OPERATOR_LOGIN';

const actionTypes = {
  OPERATOR_LOGIN,
};

export default actionTypes;
